import styled, { css } from 'styled-components';
import { padding, PaddingProps } from 'styled-system';

export const RowWrapper = styled.div<PaddingProps>`
  &:not(:last-child) {
    ${({ theme }) => css`
      border-bottom: 1px dashed ${theme.colors.gray.extraLight};
    `};
  }
  ${padding};
`;

export const ColumnValue = styled.span<PaddingProps & { fontSize: number }>`
  white-space: pre-wrap;
  ${({ theme, fontSize }) => css`
    font-size: ${theme.fontSizes[fontSize]}px;
  `};
`;

ColumnValue.defaultProps = {
  fontSize: 0,
};
